(function () {

  function initFurHeader(root) {

    const context =
      root || document;


    const header =
      context.matches?.('[data-fur-header]')
        ? context
        : context.querySelector?.('[data-fur-header]') ||
          document.querySelector('[data-fur-header]');


    if (!header) {
      return;
    }


    /* =====================================================
       ELEMENTS
    ===================================================== */

    const menuToggle =
      header.querySelector(
        '[data-fur-menu-toggle]'
      );


    const categoriesToggle =
      header.querySelector(
        '[data-fur-categories-toggle]'
      );


    const panel =
      document.querySelector(
        '[data-fur-menu-panel]'
      );


    const menuView =
      panel?.querySelector(
        '[data-fur-menu-view]'
      );


    const categoriesView =
      panel?.querySelector(
        '[data-fur-categories-view]'
      );


    const menuSymbol =
      header.querySelector(
        '[data-fur-menu-symbol]'
      );


    const categoriesSymbol =
      header.querySelector(
        '[data-fur-categories-symbol]'
      );


    if (
      !menuToggle ||
      !categoriesToggle ||
      !panel
    ) {

      console.warn(
        'THE FUR HEADER: required elements not found'
      );

      return;

    }


    if (
      header.dataset.furInitialized ===
      'true'
    ) {
      return;
    }


    header.dataset.furInitialized =
      'true';


    let activeView = null;

    let ticking = false;


    /* =====================================================
       VIEW
    ===================================================== */

    function setView(view) {

      if (menuView) {

        menuView.classList.toggle(
          'is-active',
          view === 'menu'
        );

      }


      if (categoriesView) {

        categoriesView.classList.toggle(
          'is-active',
          view === 'categories'
        );

      }


      activeView =
        view;

    }


    /* =====================================================
       BUTTON STATES
    ===================================================== */

    function updateButtons(view) {

      const menuOpen =
        view === 'menu';


      const categoriesOpen =
        view === 'categories';


      menuToggle.setAttribute(
        'aria-expanded',
        menuOpen
          ? 'true'
          : 'false'
      );


      categoriesToggle.setAttribute(
        'aria-expanded',
        categoriesOpen
          ? 'true'
          : 'false'
      );


      if (menuSymbol) {

        menuSymbol.textContent =
          menuOpen
            ? '−'
            : '+';

      }


      if (categoriesSymbol) {

        categoriesSymbol.textContent =
          categoriesOpen
            ? '−'
            : '+';

      }

    }


    /* =====================================================
       OPEN PANEL
    ===================================================== */

    function openPanel(view) {

      panel.classList.add(
        'is-open'
      );


      panel.setAttribute(
        'aria-hidden',
        'false'
      );


      setView(
        view
      );


      updateButtons(
        view
      );


      document.documentElement.classList.add(
        'fur-menu-open'
      );


      document.body.classList.add(
        'fur-menu-open'
      );

    }


    /* =====================================================
       CLOSE PANEL
    ===================================================== */

    function closePanel() {

      panel.classList.remove(
        'is-open'
      );


      panel.setAttribute(
        'aria-hidden',
        'true'
      );


      setView(
        null
      );


      updateButtons(
        null
      );


      document.documentElement.classList.remove(
        'fur-menu-open'
      );


      document.body.classList.remove(
        'fur-menu-open'
      );


      activeView =
        null;

    }


    /* =====================================================
       TOGGLE MENU
    ===================================================== */

    function toggleMenu() {

      if (
        panel.classList.contains(
          'is-open'
        ) &&
        activeView === 'menu'
      ) {

        closePanel();

      } else {

        openPanel(
          'menu'
        );

      }

    }


    /* =====================================================
       TOGGLE CATEGORIES
    ===================================================== */

    function toggleCategories() {

      if (
        panel.classList.contains(
          'is-open'
        ) &&
        activeView === 'categories'
      ) {

        closePanel();

      } else {

        openPanel(
          'categories'
        );

      }

    }


    /* =====================================================
       MENU BUTTON
    ===================================================== */

    menuToggle.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();


        toggleMenu();

      }
    );


    /* =====================================================
       CATEGORIES BUTTON
    ===================================================== */

    categoriesToggle.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();


        toggleCategories();

      }
    );


    /* =====================================================
       PANEL CLICK
       CLOSE BUTTON
    ===================================================== */

    panel.addEventListener(
      'click',
      function (event) {

        const closeButton =
          event.target.closest(
            '[data-fur-menu-close]'
          );


        if (!closeButton) {
          return;
        }


        event.preventDefault();
        event.stopPropagation();


        closePanel();

      }
    );


    /* =====================================================
       OUTSIDE CLICK
    ===================================================== */

    document.addEventListener(
      'click',
      function (event) {

        if (
          !panel.classList.contains(
            'is-open'
          )
        ) {
          return;
        }


        const clickedInsideHeader =
          header.contains(
            event.target
          );


        const clickedInsidePanel =
          panel.contains(
            event.target
          );


        if (
          !clickedInsideHeader &&
          !clickedInsidePanel
        ) {

          closePanel();

        }

      }
    );


    /* =====================================================
       ESCAPE KEY
    ===================================================== */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          panel.classList.contains(
            'is-open'
          )
        ) {

          closePanel();

        }

      }
    );


    /* =====================================================
       SCROLL STATE
    ===================================================== */

    function updateScrollState() {

      const scrollTop =
        window.scrollY ||
        document.documentElement.scrollTop ||
        0;


      header.classList.toggle(
        'fur-header--scrolled',
        scrollTop > 70
      );


      ticking =
        false;

    }


    function onScroll() {

      if (ticking) {
        return;
      }


      ticking =
        true;


      window.requestAnimationFrame(
        updateScrollState
      );

    }


    window.addEventListener(
      'scroll',
      onScroll,
      {
        passive: true
      }
    );


    updateScrollState();

  }


  /* =======================================================
     NORMAL LOAD
  ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initFurHeader();

      }
    );

  } else {

    initFurHeader();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const header =
        event.target.matches?.(
          '[data-fur-header]'
        )
          ? event.target
          : event.target.querySelector?.(
              '[data-fur-header]'
            );


      if (!header) {
        return;
      }


      delete header.dataset
        .furInitialized;


      initFurHeader(
        header
      );

    }
  );

})();